// PR-I-84: cliente del agregador GET /api/v1/bookings/summary/.
// Contrato en src/app/pages/myBookings/models.ts (owner: back PR-I-83).
// Auth: cookies HttpOnly + interceptor de apiClient; no se toca aquí.
// Fail-closed: params fuera de la allowlist del back se descartan del lado server.

import apiClient from '../helpers/apiClient'
import { handleApiError } from '../utils/handleApiError'
import {
  BookingType,
  BookingsSummary,
  BookingTypeFilter,
  TYPE_FILTER_TO_TYPE,
} from '../pages/myBookings/models'

export interface GetBookingsSummaryParams {
  type?: BookingType
}

// Traduce el filtro plural del UI a `?type=` singular; 'all' => sin param.
export const filterToQueryParam = (
  typeFilter: BookingTypeFilter,
): GetBookingsSummaryParams | undefined => {
  if (typeFilter === 'all') return undefined
  return { type: TYPE_FILTER_TO_TYPE[typeFilter] }
}

export async function getBookingsSummary(
  params?: GetBookingsSummaryParams,
): Promise<BookingsSummary | undefined> {
  try {
    const response = await apiClient.get('/bookings/summary/', { params })
    return response.data as BookingsSummary
  } catch (error) {
    handleApiError(error, {})
    return undefined
  }
}
